// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectDeliveryNoDocumentsDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_DELIVERY_NO_DOCUMENTS_DEALER
});

export const selectAllDeliveryNoDocumentsDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_DELIVERY_NO_DOCUMENTS_DEALERS
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_DELIVERY_NO_DOCUMENTS_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/action-creators/select-dealer.js